import React from "react";
import { Box, Typography, Button } from "@mui/material";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { useNavigate } from "react-router-dom";
import { useGodMode } from "../Hooks/GodModeContext";

export default function GodModeBanner() {
  const { isGodMode, impersonatedSchool, exitGodMode } = useGodMode();
  const navigate = useNavigate();

  if (!isGodMode || !impersonatedSchool) {
    return null;
  }

  return (
    <Box
      sx={{
        background: "linear-gradient(90deg, #c01e2e 0%, #8a1520 100%)",
        py: 0.5,
        px: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1.5,
      }}
    >
      <AdminPanelSettingsIcon sx={{ color: "#fff", fontSize: 16 }} />
      
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Typography sx={{ color: "#fff", fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px" }}>
          GOD MODE
        </Typography>
        <Box sx={{ width: 1, height: 12, backgroundColor: "rgba(255,255,255,0.3)" }} />
        <Typography sx={{ color: "#fff", fontSize: "11px", fontWeight: 500 }}>
          {impersonatedSchool.name}
        </Typography>
      </Box>

      <Button
        size="small"
        onClick={() => exitGodMode(navigate)}
        sx={{
          ml: 1,
          backgroundColor: "rgba(0,0,0,0.25)",
          color: "#fff",
          fontSize: "10px",
          fontWeight: 600,
          py: 0.25,
          px: 1,
          minWidth: "auto",
          textTransform: "none",
          borderRadius: "4px",
          "&:hover": {
            backgroundColor: "rgba(0,0,0,0.4)",
          },
        }}
      >
        Exit
      </Button>
    </Box>
  );
}
